class MoveElementResponsively {
  constructor(config = {}) {
    const {
      movableElementSelector,
      targetContainerSelector,
      breakpoint
    } = config;

    this.movableElement = document.querySelector(movableElementSelector);
    this.targetContainer = document.querySelector(targetContainerSelector);
    this.breakpoint = breakpoint;

    if(this.movableElement){
      // console.log(this.movableElement);
      this.originalParent = this.movableElement.parentElement;
    }

    const move = () => {
      if (this.breakpoint.matches) {
        // If media query matches
        if (this.targetContainer.contains(this.movableElement)) {
          this.targetContainer.removeChild(this.movableElement);
          this.originalParent.appendChild(this.movableElement);
        }
      } else {
        if (this.originalParent.contains(this.movableElement)) {
          this.originalParent.removeChild(this.movableElement);
          this.targetContainer.appendChild(this.movableElement);
        }
      }
    }

    if(this.originalParent){
      move();
      window.addEventListener("resize", () => {
        move();
      });
    }
  }
}
export default MoveElementResponsively;
